import axios from 'axios';

import Auth from '@/models/Auth'
import Org from '@/models/Org'
import Training from '@/models/Training'
import Agreement from '@/models/Agreement'
import Article from '@/models/Article'
import Comment from '@/models/Comment'
import Reply from '@/models/Reply'
import Proceeding from '@/models/Proceeding'

import Subject from '@/models/Subject'
import SelfTestAnswer from '@/models/test/SelfTestAnswer'
import PerformTest from '@/models/test/PerformTest'
import PerformTestAnswer from '@/models/test/PerformTestAnswer'
import PerformSelfTestAnswer from '@/models/test/PerformSelfTestAnswer'
import clone from 'clone'
import Member from '@/models/Member'

import attitude from './tests/attitude'
import writing from './tests/writing'
import portfolio from './tests/portfolio'

function toMap (obj, key) {
  return obj.reduce((acc, cur) => {
    if (cur[key]) acc[cur[key]] = cur
    return acc
  }, {})
}

export default {
  install (Vue) {
    Vue.prototype.$models = {
      Member, Training
    }

    attitude(Vue)
    portfolio(Vue)
    writing(Vue)

    Vue.prototype.$member = Member
    Vue.prototype.$Auth = Auth
    Vue.prototype.$Org = Org
    Vue.prototype.$Training = Training
    Vue.prototype.$PerformTest = PerformTest
    Vue.prototype.$PerformTestAnswer = PerformTestAnswer
    Vue.prototype.$PerformSelfTestAnswer = PerformSelfTestAnswer
    Vue.prototype.$Agreement = Agreement
    Vue.prototype.$Article = Article
    Vue.prototype.$Comment = Comment
    Vue.prototype.$Reply = Reply
    Vue.prototype.$Proceeding = Proceeding

    Vue.prototype.$cellPhone = function (cell) {
      return cell && `${cell.number1}-${cell.number2}-${cell.number3}`
    }

    Vue.prototype.$clone = clone

    Vue.prototype.$pageInfo = function (array, perPage = 10) {
      if (!array) return {}
      const totalCount = array.length
      return {
        totalCount,
        perPage,
        page: 1,
        totalPage: Math.ceil(totalCount / perPage),
        startIndex: 0,
        endIndex: perPage - 1
      }
    }
    Vue.prototype.$getTraining = async function (trainingId) {
      if (!trainingId) return undefined;
      return await Training.get(trainingId);
    };

    Vue.prototype.$getSubjects = async function (trainingId) {
      if (!trainingId) return undefined;
      return await Subject.getSubjects(trainingId);
    };

    // 포트폴리오 과목을 제외한 목록
    Vue.prototype.$normalSubjects = function (subjects) {
      return subjects
      // return subjects.filter(s => !s.portfolio)
    }
    // 평가 볼 때 비밀번호 조사
    // Vue.prototype.$checkPassword = async function (userId, password) {
    //   console.log('check password ------')
    //   console.log(Auth)
    //   return Auth.checkPassword(userId, password);
    // }

    // 자가진단 답지 받기
    Vue.prototype.$getSelfTestAnswerList = async function (query) {
      const answers = await SelfTestAnswer.list(query)
      return answers
    }

    // 자가진단 답지 받기
    Vue.prototype.$getSelfTestAnswer = async function (query) {
      const answer = await SelfTestAnswer.get(query)
      return answer
    }

    // 수행평가 문제 목록 받기
    Vue.prototype.$getPerformTestList = async function (training) {
      const test = await PerformTest.list({ training })
      return toMap(test, 'code')
    }

    // 수행평가 답지 목록 받기
    Vue.prototype.$getPerformTestAnswerList = async function (student, code) {
      const answer = await PerformTestAnswer.list({ student, code })
      // 1차, 2차 구조화
      let seq1 = answer.filter(a => a.seq === 1)
      seq1 = toMap(seq1, 'code')
      let seq2 = answer.filter(a => a.seq === 2)
      seq2 = toMap(seq2, 'code')
      return { seq1, seq2 }
    }

    // 학생 한명의 수행평가 문제지와 답지 받기
    Vue.prototype.$getPerformTestAndAnswer = async function (test, answer) {
      test = await PerformTest.get(test)
      answer = await PerformTestAnswer.get(answer)
      return { test, answer }
    }

    Vue.prototype.$forceDownload = async function (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    }

    Vue.prototype.$download = async function (url, title) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer'
      }).then((response) => {
        this.$forceDownload(response, title)
      }).catch((e) => console.log('error occured', e))
    }
  }
}
